const initProductGallery = () => {
  const allProductSections = document.querySelectorAll('[data-section-type="product"]');

  allProductSections.forEach(productSection => {
    if (productSection.classList.contains('js-gallery-initialized')) return;
    productSection.classList.add('js-gallery-initialized');

    const sectionId = productSection.getAttribute("data-section-id");

    // --- Swiper Sliders ---
    const thumbEl = productSection.querySelector(".product-thumb-slider");
    const mainEl = productSection.querySelector(".product-main-slider");
    let mainSwiper;

    if (mainEl && thumbEl) {
      if (mainEl.swiper) mainEl.swiper.destroy(true, true);
      if (thumbEl.swiper) thumbEl.swiper.destroy(true, true);

      const productThumbSlider = new Swiper(thumbEl, {
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesProgress: true,
        watchOverflow: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });

      mainSwiper = new Swiper(mainEl, {
        spaceBetween: 10,
        grabCursor: true,
        thumbs: { swiper: productThumbSlider },
      });
    }

    // Helper function to format money (Cents to Currency)
    const formatMoney = (cents) => {
      if (typeof cents === "string") cents = cents.replace(".", "");
      let value = "";
      let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      let format = window.moneyFormat || "${{amount}}";
      if (!format.match(placeholderRegex)) return cents; // Fallback

      switch (format.match(placeholderRegex)[1]) {
        case "amount":
          value = (cents / 100.0).toFixed(2);
          break;
        case "amount_no_decimals":
          value = Math.round(cents / 100.0).toFixed(0);
          break;
      }
      return format.replace(placeholderRegex, value);
    };

    // Main function to calculate and update the UI
    const updatePriceDisplay = () => {
      const quantityInput = productSection.querySelector('input[name="quantity"]');
      const quantity = parseInt(quantityInput?.value || 1);

      // --- ROBUST VARIANT DETECTION ---
      // Prioritize the visible/active sub-widget tier, then the selected variant chip
      const activeSubTier = productSection.querySelector('.sub-widget__tier.is-active');
      const activeVariantChip = productSection.querySelector('.variant-chip.selected:not(.sub-widget__tier)');

      const selectedVariantId = (activeSubTier?.dataset.variantId) ||
        (activeVariantChip?.dataset.variantId) ||
        (productSection.querySelector('input[name="id"]:checked')?.value);

      const variant = window.productVariants.find(
        (v) => v.id.toString() === selectedVariantId?.toString()
      ) || window.productVariants[0];

      if (variant) {
        let basePrice = variant.price;

        // --- CANONICAL FORM ID UPDATE ---
        const mainFormIdInput = productSection.querySelector('form[action="/cart/add"] input[name="id"]:not(.js-variant-input)');
        if (mainFormIdInput) mainFormIdInput.value = variant.id;

        // --- SUBSCRIPTION PRICE DETECTION ---
        const allWidgets = productSection.querySelectorAll('.shopify-app-block, .shopify_subscriptions_app_block, .easy-dynamic-subscription-container, .selling_plan_app_container, .appstle_subscription_wrapper, [id^="appstle_"], .product-sub-widget');
        const subWidget = Array.from(allWidgets).find(w => {
          const style = window.getComputedStyle(w);
          const isVisible = style.display !== 'none' && style.visibility !== 'hidden' && w.offsetWidth > 0;
          return isVisible && !w.closest('[style*="display: none"]');
        });

        if (subWidget) {
          const subOption = subWidget.querySelector('.sub-widget__option--subscription');
          const isSubSelected = subOption && subOption.classList.contains('is-selected');

          if (!isSubSelected) {
            basePrice = variant.price;
          } else {
            const freqSelect = subWidget.querySelector('.js-frequency-select');
            const selectedOption = freqSelect && freqSelect.selectedOptions ? freqSelect.selectedOptions[0] : null;
            const discount = selectedOption ? parseFloat(selectedOption.dataset.discount || 0) : 0;

            if (discount > 0) {
              basePrice = variant.price * (1 - (discount / 100));
            } else {
              // Fallback: Try to get discount from the widget's active tier
              const activeTier = subWidget.querySelector('.sub-widget__tier.is-active');
              const tierDiscount = activeTier ? parseFloat(activeTier.dataset.bundleSave || 0) : 0;
              // If still 0, try to find ANY discount in the frequency select
              const anyDiscount = freqSelect ? Array.from(freqSelect.options).find(opt => parseFloat(opt.dataset.discount) > 0) : null;
              const finalDiscount = tierDiscount || (anyDiscount ? parseFloat(anyDiscount.dataset.discount) : 0);
              
              if (finalDiscount > 0) {
                basePrice = variant.price * (1 - (finalDiscount / 100));
              } else {
                basePrice = variant.price;
              }
            }
          }
        }

        const priceElems = productSection.querySelectorAll('.js-current-price');
        const btnPriceElem = productSection.querySelector('.product-price-btn');
        const compareElem = productSection.querySelector('.js-compare-price');
        const totalPrice = basePrice * quantity;

        // --- SOURCE OF TRUTH CHECK ---
        // If subWidget is present, we DO NOT update any price elements here.
        // We let subscription-widget.js handle it to prevent flicker.
        if (!subWidget) {
          if (btnPriceElem) btnPriceElem.innerHTML = formatMoney(totalPrice);
          priceElems.forEach(el => {
            el.innerHTML = formatMoney(totalPrice);
          });
          if (compareElem && variant.compare_at_price) {
            compareElem.innerHTML = formatMoney(variant.compare_at_price * quantity);
            compareElem.style.display = "inline-block";
          } else if (compareElem) {
            compareElem.style.display = "none";
          }
        }

        // --- UPDATE BUTTON STATE ---
        const atcButton = productSection.querySelector('[name="add"]');
        const atcText = atcButton?.querySelector(".atc-text");

        if (atcButton) {
          const isAvailable = variant.available;
          if (isAvailable) {
            atcButton.disabled = false;
            if (atcText) atcText.innerText = atcButton.getAttribute("data-atc-text") || "Add to cart";
            atcButton.classList.remove('is-sold-out');
          } else {
            atcButton.disabled = true;
            if (atcText) atcText.innerText = "Sold out";
            atcButton.classList.add('is-sold-out');
          }
        }
      }
    };

    // --- Subscription Widget Listener ---
    const subWidgets = productSection.querySelectorAll('.shopify-app-block, .shopify_subscriptions_app_block, .easy-dynamic-subscription-container, .selling_plan_app_container, .appstle_subscription_wrapper');
    subWidgets.forEach(widget => {
      widget.addEventListener('change', () => {
        setTimeout(updatePriceDisplay, 100);
      });
      widget.addEventListener('click', (e) => {
        if (e.target.closest('input[type="radio"]') || e.target.closest('.subscription_group') || e.target.closest('.easy-subscription-item') || e.target.closest('.selling_plan_theme_integration') || e.target.closest('.purchase-option')) {
          setTimeout(updatePriceDisplay, 200);
        }
      });
    });

    document.addEventListener('product:price-updated', (e) => {
      if (e.detail && e.detail.variantId) {
        // Use the final price from the widget directly to prevent fighting/flicker
        if (e.detail.price !== undefined) {
           const priceElems = productSection.querySelectorAll('.js-current-price');
           const btnPriceElem = productSection.querySelector('.product-price-btn');
           const compareElem = productSection.querySelector('.js-compare-price');
           
           priceElems.forEach(el => {
             el.innerHTML = formatMoney(e.detail.price);
           });
           if (btnPriceElem) btnPriceElem.innerHTML = formatMoney(e.detail.price);
           
           // Optionally update compare price if it's a subscription
           if (compareElem && e.detail.isSubscription) {
             const activeTier = productSection.querySelector('.sub-widget__tier.is-active');
             const anchor = activeTier ? parseFloat(activeTier.dataset.anchorPrice) : 0;
             if (anchor > 0) {
               compareElem.innerHTML = formatMoney(anchor * (parseInt(productSection.querySelector('input[name="quantity"]')?.value) || 1));
               compareElem.style.display = "inline-block";
             }
           }
        }
      }
    });

    // --- Quantity Logic ---
    const qtyWrapper = productSection.querySelector(".quantity-selector");
    const qtyInput = qtyWrapper?.querySelector("input");
    if (qtyInput) {
      const minus = qtyWrapper.querySelector(".qty-btn.minus");
      const plus = qtyWrapper.querySelector(".qty-btn.plus");

      minus.addEventListener('click', (e) => {
        e.preventDefault();
        let val = parseInt(qtyInput.value) || 1;
        if (val > 1) {
          qtyInput.value = val - 1;
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
          updatePriceDisplay();
        }
      });
      plus.addEventListener('click', (e) => {
        e.preventDefault();
        qtyInput.value = (parseInt(qtyInput.value) || 1) + 1;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        updatePriceDisplay();
      });
      qtyInput.oninput = updatePriceDisplay;
    }

    // --- Variant Chips / Cards ---
    const variantOptions = productSection.querySelectorAll(".variant-chip, .variant-option-item");
    variantOptions.forEach((variantChip) => {
      variantChip.addEventListener('click', function () {
        variantOptions.forEach((c) => c.classList.remove("selected"));
        this.classList.add("selected");

        const radio = this.querySelector('input[type="radio"]');
        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event("change", { bubbles: true }));

          const variantId = radio.value;

          // Toggle App Sections
          const appSections = productSection.querySelectorAll('.selling_plan_theme_integration[data-variant-id], [data-easy-variant-id]');
          appSections.forEach(section => {
            const sectionVariantId = section.getAttribute('data-variant-id') || section.getAttribute('data-easy-variant-id');
            section.style.display = (sectionVariantId === variantId) ? 'block' : 'none';
          });

          // Update Image
          const imageIndex = this.getAttribute("data-image-index");
          if (imageIndex !== null && mainSwiper) {
            mainSwiper.slideTo(parseInt(imageIndex));
          }

          // Sync with Custom Subscription Widget
          const subWidget = productSection.querySelector('.product-sub-widget');
          if (subWidget) {
            const correspondingTier = subWidget.querySelector(`.sub-widget__tier[data-variant-id="${variantId}"]`);
            if (correspondingTier && !correspondingTier.classList.contains('is-active')) {
              correspondingTier.click();
            }
          }

          // Update Price
          updatePriceDisplay();
          setTimeout(updatePriceDisplay, 200);
        }
      });
    });

    // --- AJAX ADD TO CART ---
    const atcButton = productSection.querySelector('[name="add"]');
    const atcText = atcButton?.querySelector(".atc-text");

    if (atcButton) {
      atcButton.addEventListener("click", (e) => {
        e.preventDefault();

        const subWidget = productSection.querySelector('.product-sub-widget');
        const quantityInput = productSection.querySelector('[name="quantity"]');
        const quantity = quantityInput ? quantityInput.value : 1;

        let variantId;
        let sellingPlanId = null;

        if (subWidget) {
          const subOption = subWidget.querySelector('.sub-widget__option--subscription');
          const isSubSelected = subOption && subOption.classList.contains('is-selected');

          if (isSubSelected) {
            const activeSellingPlan = subWidget.querySelector('.js-selling-plan-input');
            const freqSelect = subWidget.querySelector('.js-frequency-select');
            sellingPlanId = activeSellingPlan?.value || freqSelect?.value;
          }

          const activeTier = subWidget.querySelector('.sub-widget__tier.is-active');
          variantId = activeTier ? activeTier.dataset.variantId : null;
        }

        if (!variantId) {
          const activeVariantInput = productSection.querySelector('.variant-chip.selected input[name="id"]');
          variantId = activeVariantInput ? activeVariantInput.value : (productSection.querySelector('[name="id"]')?.value || productSection.querySelector('input[name="id"]')?.value);
        }

        if (!variantId && window.productVariants && window.productVariants.length > 0) {
          variantId = window.productVariants[0].id;
        }

        // --- MANUAL FORMDATA CONSTRUCTION (FORCEFUL) ---
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', quantity);
        if (sellingPlanId && sellingPlanId !== "") {
          formData.append('selling_plan', sellingPlanId);
        }

        console.log("[FORCE ATC] Sending Data:", {
          id: variantId,
          selling_plan: sellingPlanId,
          quantity: quantity
        });

        atcButton.classList.add("loading");
        atcButton.disabled = true;

        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          body: formData,
          headers: { "X-Requested-With": "XMLHttpRequest" },
        })
          .then((response) => {
            if (!response.ok) {
              return response.json().then((err) => {
                throw err;
              });
            }
            return response.json();
          })
          .then((item) => {
            updateCartCount();
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { open: true } }));

            atcButton.classList.remove("loading");
            atcButton.classList.add("success");
            if (atcText) atcText.innerText = atcButton.getAttribute("data-added-text") || "Added! ✓";

            setTimeout(() => {
              atcButton.disabled = false;
              atcButton.classList.remove("success");
              if (atcText) atcText.innerText = atcButton.getAttribute("data-atc-text") || "Add to cart";
            }, 2000);
          })
          .catch((error) => {
            console.error("Cart Error:", error);
            atcButton.classList.remove("loading");

            let errorMessage = "Error adding to cart";
            if (error.description) errorMessage = error.description;
            else if (error.message) errorMessage = error.message;

            if (atcText) atcText.innerText = errorMessage;

            setTimeout(() => {
              atcButton.disabled = false;
              if (atcText) atcText.innerText = atcButton.getAttribute("data-atc-text") || "Add to cart";
            }, 3000);
          });
      });
    }
  });
};

function updateCartCount() {
  fetch(window.Shopify.routes.root + "cart.js")
    .then((res) => res.json())
    .then((cart) => {
      const bubble = document.querySelector(".cart-count-bubble");
      if (bubble) {
        bubble.textContent = cart.item_count;
        bubble.classList.remove("hidden");
      }
    });
}

const initProductDescription = () => {
  const container = document.querySelector(".product-description-container");
  if (!container) return;

  const content = container.querySelector(".js-desc-content");
  const btn = container.querySelector(".js-show-more");
  if (!content || !btn) return;

  const isEnabled = container.getAttribute("data-show-more-enabled") === "true";
  const collapsedHeight = parseInt(container.getAttribute("data-collapsed-height")) || 300;

  if (!isEnabled) {
    btn.style.display = "none";
    content.classList.remove("is-collapsed");
    return;
  }

  setTimeout(() => {
    const fullHeight = content.scrollHeight;
    if (fullHeight > collapsedHeight) {
      btn.style.display = "block";
      const moreText = btn.querySelector(".btn-text-more");
      const lessText = btn.querySelector(".btn-text-less");

      btn.onclick = () => {
        const isCollapsed = content.classList.contains("is-collapsed");
        if (isCollapsed) {
          content.classList.remove("is-collapsed");
          content.classList.add("is-expanded");
          content.style.maxHeight = fullHeight + "px";
          if (moreText) moreText.style.display = "none";
          if (lessText) lessText.style.display = "inline";
        } else {
          content.classList.add("is-collapsed");
          content.classList.remove("is-expanded");
          content.style.maxHeight = collapsedHeight + "px";
          if (moreText) moreText.style.display = "inline";
          if (lessText) lessText.style.display = "none";
          container.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      };
    } else {
      btn.style.display = "none";
      content.classList.remove("is-collapsed");
    }
  }, 100);
};

const initStandaloneShare = () => {
  const modal = document.getElementById("GlobalShareModal");
  if (!modal) return;

  const triggers = document.querySelectorAll(".js-share-trigger");
  const overlay = modal.querySelector(".share-modal__overlay");
  const closeBtn = modal.querySelector(".share-modal__close");
  const facebookBtn = modal.querySelector(".js-facebook-share");
  const twitterBtn = modal.querySelector(".js-twitter-share");
  const copyBtn = modal.querySelector(".js-copy-link");
  const copyText = modal.querySelector(".js-copy-text");

  const openModal = (url, title) => {
    facebookBtn.href = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
    twitterBtn.href = `https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(url)}`;
    copyBtn.setAttribute("data-url", url);
    modal.classList.add("is-open");
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    modal.classList.remove("is-open");
    document.body.style.overflow = "";
  };

  triggers.forEach((btn) => {
    btn.onclick = (e) => {
      e.preventDefault();
      const url = btn.getAttribute("data-share-url") || window.location.href;
      const title = document.title;
      openModal(url, title);
    };
  });

  overlay.onclick = closeModal;
  closeBtn.onclick = closeModal;

  if (copyBtn) {
    copyBtn.onclick = () => {
      const urlToCopy = copyBtn.getAttribute("data-url");
      const defaultText = copyText.innerText;
      const successText = copyText.getAttribute("data-link-copied") || "Link Copied! ✓";

      navigator.clipboard.writeText(urlToCopy).then(() => {
        copyText.innerText = successText;
        setTimeout(() => {
          copyText.innerText = defaultText;
        }, 2000);
      });
    };
  }
};

const initAllScripts = () => {
  initStandaloneShare();
  initProductGallery();
  initProductDescription();
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initAllScripts);
} else {
  initAllScripts();
}

document.addEventListener("shopify:section:load", () => {
  initStandaloneShare();
  initProductGallery();
  initProductDescription();
});
